module.exports = __webpack_public_path__ + "img/logo.8dcaa561.svg";